import React, { useState } from "react";
import { connect } from "react-redux";
import PerformanceCard from "components/card/PerformanceCard";
import HeaderComponent from "components/card/HeaderComponent";
import { Button } from "antd";
import ReviewDetails from "./ReviewDetails";
import HeaderModal from "components/modal/HeaderModal";

const ConductReviewsTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeRecord, setActiveRecord] = useState(null);

  const recordList = [
    {
      name: "Jennifer Lee",
      role: "Senior Developer",
      department: "Engineering",
      lastDate: "Jul 15, 2025",
      nextDate: "Oct 15, 2025",
      dueStatus: "Due",
      reviewCount: "1",
    },
    {
      name: "Mark Reyes",
      role: "UX Designer",
      department: "Design",
      lastDate: "Aug 10, 2025",
      nextDate: "Nov 10, 2025",
      dueStatus: "Upcoming",
      reviewCount: "0",
    },
    {
      name: "Emily Rodriguez",
      role: "Frontend Developer",
      department: "Engineering",
      lastDate: "Jul 15, 2025",
      nextDate: "Oct 15, 2025",
      dueStatus: "Overdue",
      reviewCount: "1",
    },
  ];

  const openModal = (record) => {
    setActiveRecord(record);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setActiveRecord(null);
    setIsModalOpen(false);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-3 mb-3">
      {recordList.map((record, index) => (
        <PerformanceCard
          key={index}
          name={record.name}
          role={record.role}
          department={record.department}
          lastDate={record.lastDate}
          nextDate={record.nextDate}
          dueStatus={record.dueStatus}
        >
          <div className="w-full flex flex-col space-y-2">
            <a
              className="btn btn-gradient-emerald p-2 text-sm w-full block text-center hover:text-white"
              href="performance-reviews/1/edit"
            >
              + Start Review
            </a>

            <Button
              onClick={() => openModal(record)}
              className="w-full mt-2 rounded-xl bg-white text-gray-800 h-8 text-sm"
            >
              See All Reviews
            </Button>
          </div>
        </PerformanceCard>
      ))}

      {activeRecord && (
        <HeaderModal
          open={isModalOpen}
          onClose={closeModal}
          icon={null} // optional
          title={`All Reviews - ${activeRecord.name}`}
          description={`${activeRecord.role} • ${activeRecord.reviewCount} reviews on file`}
          bgcolor="white"
          footer={
            <div className="p-4 flex justify-end mt-4">
              <Button
                className="inline-flex items-center justify-center gap-2 rounded-xl text-sm bg-green-500 text-white font-medium h-9 px-4"
                onClick={closeModal}
              >
                Close
              </Button>
            </div>
          }
        >
          <div className="max-h-[60vh] overflow-y-auto pr-2 space-y-4">
            <ReviewDetails
              quarter="Q2 2025"
              reviewDate="July 15, 2025"
              clientName="John Smith"
            />
            <ReviewDetails
              quarter="Q2 2025"
              reviewDate="July 15, 2025"
              clientName="John Smith"
            />
          </div>
        </HeaderModal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ConductReviewsTable);
